import React, { useState } from 'react';
import Title from '../../../Components/Common/Atoms/Title';
import Text from '../../../Components/Common/Text/Text';
import Link from '../../../Components/Common/Link/Link';
import Label from '../../../Components/Common/Atoms/Form/Label';
import RadioInput from '../../../Components/Common/Atoms/Form/RadioInput';
import FormRow from '../../../Components/Common/Atoms/Form/FormRow';
import FormCol from '../../../Components/Common/Atoms/Form/FormCol';
import InputBox from '../../../Components/Common/Atoms/Form/InputBox';
import Button from '../../../Components/Common/Modules/Button';
import Wizard from '../../../Components/Common/Modules/Wizard';
import InfoCard from '../../../Components/Common/Modules/InfoCard';
import Modal from '../../../Components/Common/Organism/Modal';
import useListarTarjetasDeCreditoPaywall from '../../../Hooks/useListarTarjetasDeCreditoPaywall';
import LoadingSpinner from '../../../Helpers/LoadingSpinner';
import IframeTarjeta from '../IframeTarjeta';
import ErrorBoundary from '../../../Components/Common/Organism/ErrorBoundary';
import PathsConfig from '../../../Config/RoutePaths';
import { useHistory } from 'react-router';
import useCambioInstrumentoDeCobro from '../../../Hooks/useCambioInstrumentoDeCobro';
import useRedirectWithout from '../../../Hooks/useRedirectWithout';
import Breadcrumb from '../../../Components/Common/Modules/Breadcrumb';
import TitleWeb from '../../../Components/Common/Web/Title';
import steps from '../../../Config/StepsCambioFormaDePago';
import '../../../Statics/Scss/Pages/SelectPaymentMethod.scss';

const SelectPaymentMethod = (props) => {
    const stepProps = ['suscripciones', 'motivo'];
    const { suscripciones, motivo } = useRedirectWithout(props.location.state, stepProps, PathsConfig.ElegirSuscripcion);
    const history = useHistory();
    const [confirmationModal, setConfirmationModal] = useState(false);
    const [tarjetas, errorTarjetas, isLoadingTarjetas] = useListarTarjetasDeCreditoPaywall();
    const [dataCambioFormaDePago, errorCambioFormaDePago, isLoadingCambioFormaDePago, cambiarFormaDePago] = useCambioInstrumentoDeCobro();
    const noCardRegistered = tarjetas?.length < 1;
    const [selected, setSelected] = useState();
    const [dataNuevaTarjeta, setDataNuevaTarjeta] = useState();
    const [nombresSuscripciones, setNombresSuscripciones] = useState();
    const [cardState, setCardState] = useState({
        cardSelected: false,
        newCard: false,
    });
    const [formState, setFormState] = useState({
        error: false,
        msg: '',
    });

    const handleChange = (tarjeta) => {
        setSelected(tarjeta);
        setCardState({ cardSelected: true });
        setFormState(false);
    };
    const handleFormState = () => {
        if (noCardRegistered === true || !cardState.cardSelected) {
            setFormState({
                error: true,
                msg: 'Seleccioná un medio de pago',
            });
        } else {
            saveNamesAllSuscriptions();
            setConfirmationModal(true);
        }
    };

    //obtengo un string con los nombres de todas las suscripciones
    const saveNamesAllSuscriptions = () => {
        let str = '';
        suscripciones.forEach((s, index) => {
            if (index == suscripciones.length - 1) {
                str += s.nombreSuscripcion;
            } else {
                str += s.nombreSuscripcion + ' , ';
            }
        });
        setNombresSuscripciones(str);
    };

    const getCardType = (tarjeta) => {
        if (tarjeta.InstrumentoDeCobro.Nombre.toLowerCase().includes('american')) {
            return 'American';
        } else if (tarjeta.InstrumentoDeCobro.Nombre.toLowerCase().includes('visa')) {
            return 'Visa';
        } else if (tarjeta.InstrumentoDeCobro.Nombre.toLowerCase().includes('master')) {
            return 'Master';
        } else {
            return '';
        }
    };

    const getPayload = (nuevaTarjeta) => {
        let idSuscripciones = [];
        suscripciones.forEach((s) => {
            idSuscripciones.push(s.idSuscription);
        });
        const payload = {
            idMotivo: motivo,
            idSuscripciones: idSuscripciones,
            idTarjeta: nuevaTarjeta ? null : selected?.Id,
        };
        return payload;
    };

    const handleNuevaTarjeta = () => {
        setDataNuevaTarjeta(getPayload(true));
        setCardState({ newCard: true });
    };

    const handleCambioFormaDePago = () => {
        const sendPayload = getPayload(false);
        setConfirmationModal(false);
        cambiarFormaDePago(sendPayload)
            .then((resp) => {
                history.push({
                    pathname: PathsConfig.CambiarFormaDePagoFinalizado,
                    state: {
                        succeed: resp.code == '0000',
                        tarjeta: selected.UltimosNumeros,
                        suscripciones: suscripciones,
                        nroGestion: resp.code == '0000' ? resp.message : null,
                    },
                });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    };

    return (
        <>
            <section className="container-streched">
                <section>
                    <Breadcrumb firstItem="Mis Pagos" text="Cambiar forma de pago" href="#" />

                    <TitleWeb text="Cambiar forma de pago" />
                </section>
                <LoadingSpinner withBody isLoading={isLoadingTarjetas || isLoadingCambioFormaDePago}>
                    <ErrorBoundary error={errorTarjetas || errorCambioFormaDePago}>
                        <Wizard steps={steps} activeStep={2} />
                        {!cardState.newCard && (
                            <>
                                <Title size="--s" mod="--font-bold --mb-24">
                                    Elegí un medio de pago
                                </Title>

                                <form action="#">
                                    <Label
                                        text="Mis medios de pago"
                                        link={
                                            <Link className="com-link" onClick={handleNuevaTarjeta}>
                                                + Nueva tarjeta
                                            </Link>
                                        }
                                    />
                                    {!noCardRegistered ? (
                                        <FormRow>
                                            {tarjetas?.map((tarjeta) => {
                                                return (
                                                    <FormCol className="--mb-8">
                                                        <InputBox
                                                            error={formState.error}
                                                            input={
                                                                <RadioInput onChange={() => handleChange(tarjeta)} name="payment-method">
                                                                    <InfoCard
                                                                        cardType={getCardType(tarjeta)}
                                                                        lastNumbers={tarjeta.UltimosNumeros}
                                                                        className="--mb-0"
                                                                        bank={tarjeta.Banco ? tarjeta.Banco.Nombre : ''}
                                                                        isCompact
                                                                    />
                                                                </RadioInput>
                                                            }
                                                        />
                                                    </FormCol>
                                                );
                                            })}
                                            {formState.error && (
                                                <Text tag="p" size="5xs" className="--mt-8" color="#E2342D">
                                                    {formState.msg}
                                                </Text>
                                            )}
                                        </FormRow>
                                    ) : (
                                        <FormRow>
                                            <FormCol className="--mb-8">
                                                <InputBox
                                                    error={formState.error}
                                                    input={
                                                        <Text>
                                                            No tenés medios de pago registrados, <strong>agregá uno nuevo</strong>
                                                        </Text>
                                                    }
                                                />
                                            </FormCol>
                                        </FormRow>
                                    )}
                                    <Button label="Cambiar medio de pago" mod="primary" className="state--mobile-w100" onClick={handleFormState} />
                                    <Button
                                        label="Volver"
                                        mod="tertiary"
                                        className="state--mobile-w100 --mt-0"
                                        onClick={() =>
                                            history.push({
                                                pathname: PathsConfig.ElegirSuscripcion,
                                            })
                                        }
                                    />
                                </form>
                            </>
                        )}
                        {cardState.newCard && (
                            <div>
                                <Text size="--s --font-bold" mod="h4">
                                    Nueva Tarjeta
                                </Text>
                                <div>
                                    <IframeTarjeta
                                        nuevaTarjeta={true}
                                        payloadNuevaTarjeta={dataNuevaTarjeta}
                                        suscripciones={suscripciones}
                                        iframeHeight={230}
                                    />
                                    <Button label="Volver" onClick={() => setCardState({ newCard: false })} className="--mb-8 --tertiary" />
                                </div>
                            </div>
                        )}
                        {confirmationModal && (
                            <Modal onClose={!confirmationModal}>
                                <form>
                                    <Text size="2xs" className="--arial">
                                        Estás por cambiar tu medio de pago por la tarjeta:{' '}
                                        <strong>{`${selected.UltimosNumeros} ${selected.InstrumentoDeCobro.Nombre}`} </strong>
                                        <br />
                                        <br />
                                        Para las siguientes suscripciones: <strong>{nombresSuscripciones}</strong>
                                    </Text>

                                    <div className="cambiar-pago-buttons">
                                        <Button
                                            tag="button"
                                            label="Confirmar"
                                            className="state--mobile-w100 --mt-32 --mb-0 --mr-16"
                                            onClick={() => handleCambioFormaDePago()}
                                        />
                                        <Button
                                            tag="button"
                                            label="Cancelar"
                                            mod="tertiary"
                                            className="state--mobile-w100 --mt-32 --mb-0 --ml-0"
                                            onClick={() => setConfirmationModal(false)}
                                        />
                                    </div>
                                </form>
                            </Modal>
                        )}
                    </ErrorBoundary>
                </LoadingSpinner>
            </section>
        </>
    );
};

export default SelectPaymentMethod;
